import {
  Button,
  FormControl,
  Grid,
  IconButton,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Layout } from '../../components/ui/Layout';
import MUIDataTable from 'mui-datatables';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from '../../components/ui/Spinner';
import { NUMROWSTATEINVOICE } from '../../utils/constants';
import clsx from 'clsx';
import { useTableStyles } from '../../styles/useTableUsersStyles';
import { navigate } from '@reach/router';
import {
  startLoadingFacturasList,
  changeFacturasListDateRange,
  changeFacturasListFilter,
  startHandlingFacturasFilter,
  downloadFacturasCSV,
  downloadLineasFacturadasCSV,
} from '../../redux/actions/facturasListService';
import { downloadFactura, sendFacturaCustomer } from '../../redux/actions/facturasService';
import { Form, Formik } from 'formik';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import esLocale from 'date-fns/locale/es';
import moment from 'moment-timezone';
import { getSimboloMoneda } from '../../utils/utils';
import { formatImporte } from '../../utils/money';
import GetAppIcon from '@material-ui/icons/GetApp';
import EmailIcon from '@mui/icons-material/Email';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { Box } from '@mui/system';
import { Tooltip } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import { useDebounce } from '../../hooks/useDebounce';
import { useDebounceComplex } from '../../hooks/useDebounceComplex';

moment.tz.setDefault('Europe/Madrid');

const FacturasScreen = () => {
  const result = [];
  const theme = useTheme();
  const classes = useTableStyles();
  const dispatch = useDispatch();
  const matchesXS = useMediaQuery(theme.breakpoints.down('xs'));
  const matchesMD = useMediaQuery(theme.breakpoints.down('md'));
  const { menuState, loading } = useSelector(state => state.ui);
  const { moneda: monedaUsuario } = useSelector(state => state.auth);

  const {
    facturasList,
    loading: facturasLoading,
    count,
    page,
    dateRange,
    currentFilter: filterOptions,
  } = useSelector(state => state.facturasList);

  //Estados para guardar nombres seleccionados en los filtros
  const [selectedClienteName, setSelectedClienteName] = useState('');
  const [selectedVendedorName, setSelectedVendedorName] = useState('');

  const [searchClientes, debounceSearchResultClientes] = useDebounceComplex('/clientes/search/', {
    start: 'Nombre',
    second: 'Apellidos',
    end: 'Email',
    id: 'PkClientes',
  });

  const [searchUsuarios, debounceSearchResultUsuarios] = useDebounce('/usuarios?filter[where][Nombre][like]', {
    start: 'Nombre',
    end: 'Email',
    id: 'PkUsuarios',
  });

  const getClienteNombreCompleto = (cliente) => {
    if (!cliente) return '-';
    const nombre = cliente.Nombre || '';
    const apellidos = cliente.Apellidos || '';
    return apellidos ? `${nombre} ${apellidos}`.trim() : nombre;
  };

  const getVendedorNombreCompleto = (usuario) => {
    if (!usuario) return '-';
    const nombre = usuario.Nombre || '';
    const apellidos = usuario.Apellidos || '';
    return apellidos ? `${nombre} ${apellidos}`.trim() : nombre;
  };

  useEffect(() => {
    dispatch(startHandlingFacturasFilter(filterOptions, page, dateRange));
  }, []);

  const handleDownloadFactura = (PkFacturas, facturaName) => {
    dispatch(downloadFactura(PkFacturas, facturaName));
  };

  const handleSendMailCustomer = PkFacturas => {
    dispatch(sendFacturaCustomer(PkFacturas));
  };

  const handleNavigateToSale = PkVentas => {
    if (PkVentas) {
      navigate(`/sales/invoice/${PkVentas}`);
    }
  };

  const handleDownloadCSVFacturas = () => {
    dispatch(downloadFacturasCSV(filterOptions, dateRange));
  };

  const handleDownloadCSVLineasFacturadas = () => {
    dispatch(downloadLineasFacturadasCSV(filterOptions, dateRange));
  };

  const columns = [
    {
      label: 'Nombre',
      name: 'NombreFactura',
      options: {
        filter: false,
        display: true,
        sort: false,
      },
    },
    {
      label: 'Fecha',
      name: 'FechaFactura',
      options: {
        filter: false,
        display: true,
        sort: false,
      },
    },
    {
      label: `Importe (${getSimboloMoneda(monedaUsuario)})`,
      name: 'ImporteFactura',
      options: {
        filter: false,
        display: true,
        sort: false,
      },
    },
    {
      label: 'Estado',
      name: 'EstadoERP',
      options: {
        filter: false,
        display: true,
        sort: false,
      },
    },
    {
      label: 'Fecha Envío',
      name: 'FechaEnvioFactura',
      options: {
        filter: false,
        display: !matchesXS,
        sort: false,
      },
    },
    {
      label: 'Tipo',
      name: 'TipoFactura',
      options: {
        filter: false,
        display: true,
        sort: false,
      },
    },
    {
      label: 'Fecha de Alta',
      name: 'FechaAlta',
      options: {
        filter: false,
        display: false,
        sort: false,
      },
    },
    {
      label: 'Cliente',
      name: 'Cliente',
      options: {
        filter: true,
        filterList: filterOptions ? filterOptions[7] : [],
        display: !matchesXS,
        sort: false,
        filterType: 'custom',
        customFilterListOptions: {
          render: v => (v && selectedClienteName ? `Cliente: ${selectedClienteName}` : ''),
        },
        filterOptions: {
          display: (filterList, onChange, index, column) => {
            return (
              <FormControl>
                <Autocomplete
                  id="combo-box-client"
                  options={searchClientes}
                  sx={{ width: 300 }}
                  noOptionsText="Escriba para buscar clientes"
                  onInputChange={debounceSearchResultClientes}
                  onChange={(event, newInputValue) => {
                    filterList[7][0] = newInputValue?.value;
                    setSelectedClienteName(newInputValue?.label?.split(',')[0] || '');
                    onChange(filterList[7], index, column);
                  }}
                  renderInput={params => <TextField {...params} label="Cliente" placeholder="Escriba para buscar..." />}
                />
              </FormControl>
            );
          },
        },
      },
    },
    {
      label: 'Vendedor',
      name: 'Vendedor',
      options: {
        filter: true,
        filterList: filterOptions ? filterOptions[8] : [],
        display: !matchesXS,
        sort: false,
        filterType: 'custom',
        customFilterListOptions: {
          render: v => (v && selectedVendedorName ? `Vendedor: ${selectedVendedorName}` : ''),
        },
        filterOptions: {
          display: (filterList, onChange, index, column) => {
            return (
              <FormControl>
                <Autocomplete
                  id="combo-box-vendedor"
                  options={searchUsuarios}
                  sx={{ width: 300 }}
                  noOptionsText="Escriba para buscar vendedores"
                  onInputChange={debounceSearchResultUsuarios}
                  onChange={(event, newInputValue) => {
                    filterList[8][0] = newInputValue?.value;
                    setSelectedVendedorName(newInputValue?.label?.split(',')[0] || '');
                    onChange(filterList[8], index, column);
                  }}
                  renderInput={params => <TextField {...params} label="Vendedor" placeholder="Escriba para buscar..." />}
                />
              </FormControl>
            );
          },
        },
      },
    },
    {
      label: 'Nº Venta',
      name: 'NumeroVenta',
      options: {
        filter: false,
        display: !matchesXS,
        sort: false,
      },
    },
    {
      label: 'Comentarios',
      name: 'Comentarios',
      options: {
        filter: false,
        display: !matchesXS,
        sort: false,
      },
    },
    {
      name: 'Acciones',
      options: {
        filter: false,
        display: true,
        sort: false,
        customBodyRenderLite: dataIndex => {
          const factura = facturasList[dataIndex];
          return (
            <Box display={'flex'} flexDirection={'row'} gap={1}>
              <Tooltip title="Descargar factura">
                <IconButton
                  size="small"
                  onClick={e => {
                    e.stopPropagation();
                    handleDownloadFactura(factura.PkFacturas, factura.NombreFactura);
                  }}>
                  <GetAppIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="El envío de facturas a cliente está deshabilitado en período depruebas de facturación"> 
                <IconButton
                  size="small"
                  disabled={true} // Habilitar en cambio de tenant a facturación real. Cambiar tooltip en caso de habilitar
                  onClick={e => {
                    e.stopPropagation();
                    handleSendMailCustomer(factura.PkFacturas);
                  }}>
                  <EmailIcon />
                </IconButton>
              </Tooltip>
            </Box>
          );
        },
        setCellHeaderProps: () => {
          return {
            className: clsx({
              [classes.NameCell]: true,
            }),
            style: {
              fontSize: 15,
              fontWeight: 500,
            },
          };
        },
      },
    },
  ];

  const options = {
    filterType: 'custom',
    responsive: 'standard',
    filename: 'Facturas',
    rowsPerPage: NUMROWSTATEINVOICE,
    serverSide: true,
    count: count,
    page,
    rowsPerPageOptions: [],
    onTableChange: (action, tableState) => {
      if (action === 'changePage') {
        dispatch(startHandlingFacturasFilter(tableState.filterList, tableState.page, dateRange));
      }
    },
    onFilterChange: (_, filterList) => {
      dispatch(changeFacturasListFilter(filterList, page, dateRange));
    },
    print: false,
    download: false,
    selectableRowsHideCheckboxes: true,
    selectableRowsOnClick: false,
    draggableColumns: {
      enabled: true,
    },
    textLabels: {
      body: {
        noMatch: loading || facturasLoading ? <Spinner /> : 'Lo siento, no se han encontrado registros',
      },
      pagination: {
        next: 'Siguiente',
        previous: 'Anterior',
        rowsPerPage: 'Filas por página',
        displayRows: 'de',
      },
      toolbar: {
        search: 'Buscar',
        downloadCsv: 'Descargar CSV',
        viewColumns: 'Consultar Columnas',
        filterTable: 'Filtrar Tabla',
      },
      filter: {
        all: 'Incluir dados de baja',
        title: 'Filtros',
        reset: 'Reset',
      },
      viewColumns: {
        title: 'Mostrar Columnas',
        titleAria: 'Mostrar/Ocultar Columnas Tablas',
      },
      selectedRows: {
        text: 'fila(s) seleccionadas',
        delete: 'Borrar',
        deleteAria: 'Borrar filas seleccionadas',
      },
    },
    searchOpen: false,
    search: false,
    onRowClick: (rowData, rowMeta) => {
      const factura = facturasList[rowMeta.dataIndex];
      if (factura?.FkVentas) {
        handleNavigateToSale(factura.FkVentas);
      }
    },
  };

  // Mapeo facturas
  facturasList.map(factura => {
    result.push([
      factura.NombreFactura || '-',
      factura.FechaFactura ? moment(factura.FechaFactura).format('DD/MM/YYYY') : 'Sin fecha',
      formatImporte(factura.ImporteFactura, monedaUsuario),
      factura.EstadoERP || '-',
      factura.FechaEnvioFactura ? moment(factura.FechaEnvioFactura).format('DD/MM/YYYY') : 'Sin fecha',
      factura.TipoFactura || '-',
      factura.FechaAlta ? moment(factura.FechaAlta).format('DD/MM/YYYY HH:mm') : 'Sin fecha',
      getClienteNombreCompleto(factura.Venta?.Cliente),
      getVendedorNombreCompleto(factura.Venta?.Usuario),
      factura.FkVentas || '-',
      factura.Comentarios || '-',
    ]);
    return null;
  });

  return (
    <Layout>
      <Helmet>
        <title>Facturas | Xplora</title>
      </Helmet>

      <div
        style={{
          marginTop: '2rem',
          display: 'flex',
          flexDirection: 'column',
          width: `${matchesXS ? '95vw' : matchesMD ? (menuState ? '55vw' : '85vw') : menuState ? '82vw' : '91vw'}`,
        }}>
        {!matchesXS && (
          <Typography variant="h2" style={{ marginLeft: '1.7rem' }}>
            FACTURAS
          </Typography>
        )}

        <Grid container spacing={2} alignItems="center" style={{ marginTop: '0.8rem' }}>
          <Grid item xs={12} md={6}>
            <LocalizationProvider dateAdapter={AdapterDateFns} locale={esLocale}>
              <Formik
                initialValues={{
                  FechaDesde: dateRange[0],
                  FechaHasta: dateRange[1],
                }}>
                {({ values, setFieldValue }) => (
                  <Form>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6} classes={{ root: classes.container }}>
                        <DesktopDatePicker
                          name="FechaDesde"
                          keyboard
                          label={`Fecha Desde`}
                          format="dd/MM/yyyy"
                          placeholder="10/10/2018"
                          mask={value =>
                            value ? [/[0-3]/, /\d/, '/', /0|1/, /\d/, '/', /1|2/, /\d/, /\d/, /\d/] : []
                          }
                          disableOpenOnEnter
                          onChange={value => {
                            let dateselected = moment(value).add(2, 'hours').utcOffset(0);
                            dateselected.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
                            dateselected.toISOString();
                            dateselected.format();

                            setFieldValue(`FechaDesde`, value);
                            dispatch(changeFacturasListDateRange([dateselected, dateRange[1]]));
                          }}
                          value={values.FechaDesde}
                          renderInput={params => <TextField {...params} />}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} classes={{ root: classes.container }}>
                        <DesktopDatePicker
                          name="FechaHasta"
                          keyboard
                          label={`Fecha Hasta`}
                          format="dd/MM/yyyy"
                          placeholder="10/10/2018"
                          mask={value =>
                            value ? [/[0-3]/, /\d/, '/', /0|1/, /\d/, '/', /1|2/, /\d/, /\d/, /\d/] : []
                          }
                          disableOpenOnEnter
                          onChange={value => {
                            let dateselected = moment(value).add(2, 'hours').utcOffset(0);
                            dateselected.set({ hour: 23, minute: 59, second: 59, millisecond: 0 });
                            dateselected.toISOString();
                            dateselected.format();

                            setFieldValue(`FechaHasta`, value);
                            dispatch(changeFacturasListDateRange([dateRange[0], dateselected]));
                          }}
                          value={values.FechaHasta}
                          renderInput={params => <TextField {...params} />}
                        />
                      </Grid>
                    </Grid>
                  </Form>
                )}
              </Formik>
            </LocalizationProvider>
          </Grid>

          <Grid item xs={12} md={6}>
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item>
                <Button
                  variant="contained"
                  color="default"
                  onClick={handleDownloadCSVFacturas}
                  startIcon={<CloudDownloadIcon />}>
                  CSV FACTURAS
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="default"
                  onClick={handleDownloadCSVLineasFacturadas}
                  startIcon={<CloudDownloadIcon />}>
                  CSV LINEAS FACTURADAS
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <MUIDataTable data={result} columns={columns} options={options} />
      </div>
    </Layout>
  );
};

export default FacturasScreen;
